<template>
    <div
        v-click-outside="() => toggleRegionsList()"
        class="user-region"
    >
        <button
            class="user-region__current flat-btn pointer"
            @click="toggleRegionsList(!isRegionsListVisible)"
        >
            <nuxt-img
                src="icons/location-arrow.svg"
                class="user-region__current-icon"
                alt=""
            />
            <span>
                {{ activeRegion.name || 'Выберите регион' }}
            </span>
        </button>
        <UserRegionsList
            :is-active="isRegionsListVisible"
            :active-region="activeRegion"
            @select="setSelectedRegion"
        />
    </div>
</template>

<script>
import {defineComponent, computed, ref, onMounted, nextTick} from 'vue';
import {useContext, useFetch} from '@nuxtjs/composition-api';

import {useRegionsStore} from '@/stores/regions';
import {DEFAULT_PARAMS, USER_LOCATION} from '@/core/constants/cookies';
import UserRegionsList from '@/components/UserRegions/UserRegionsList.vue';

export default defineComponent({
    components: {
        UserRegionsList,
    },
    setup() {
        const {$cookies, $fetchVisitorLead} = useContext();

        const regionsStore = useRegionsStore();
        const {
            setUserRegion,
            detectUserLocationByCoords,
            checkUserLocationCookie,
            toggleRegionModalActivity,
        } = regionsStore;

        const isRegionsListVisible = ref(false);

        const userRegion = computed(() => regionsStore.userRegion);
        const activeRegion = computed(() => regionsStore.activeRegion);

        onMounted(() => {
            nextTick().then(checkUserRegion);
        });

        useFetch(async() => {
            await checkUserLocationCookie();
        });

        async function checkUserRegion() {
            if (userRegion.value) {
                return;
            }

            try {
                const region = await detectUserLocationByCoords();

                if (region) {
                    $cookies.set(USER_LOCATION, JSON.stringify(region), DEFAULT_PARAMS);
                    $fetchVisitorLead(true);
                } else {
                    setUserRegion(activeRegion.value);
                    $cookies.set(USER_LOCATION, JSON.stringify(userRegion.value), DEFAULT_PARAMS);
                    toggleRegionModalActivity(true);
                }
            } catch (error) {
                console.error(error);
            }
        }

        function toggleRegionsList(activity = false) {
            isRegionsListVisible.value = activity;
        }

        function setSelectedRegion(region) {
            if (region.name.toLowerCase() === activeRegion.value.name.toLowerCase()) {
                return;
            }

            $cookies.set(USER_LOCATION, JSON.stringify(region), DEFAULT_PARAMS);
            setUserRegion(region);
            toggleRegionsList();
            $fetchVisitorLead(true);
        }

        return {
            activeRegion,
            isRegionsListVisible,
            toggleRegionsList,
            setSelectedRegion,
        };
    },
});
</script>

<style lang="scss">
.user-region {
    position: relative;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;

    &__current {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 8px;
        color: var(--color-shape-40);
        transition: color 0.3s ease;

        @include hover {
            color: var(--color-text-0);
        }

        &-icon {
            margin-right: 4px;
            max-width: unset;
        }
    }
}
</style>
